module.exports = __webpack_public_path__ + "static/img/oreo.4ad104b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/oreo.gif
// module id = ybe8
// module chunks = 1